import { Children } from "react";
function findByType(type) {
    return this.find((child) => child.type === type);
}
function filterByType(type) {
    return this.filter((child) => child.type === type);
}
function filterOutType(type) {
    return this.filter((child) => child.type !== type);
}
const parseChildren = (reactChildren) => {
    const children = Children.toArray(reactChildren);
    children.findByType = findByType;
    children.filterByType = filterByType;
    children.filterOutType = filterOutType;
    return children;
};
export default parseChildren;
